module.exports = [
    'dpresults_accommodation',
    'dpresults_accommodation_details',
    'dpresults_flights',
    'details',
    'payment',
];
